import {createListenerMiddleware} from '@reduxjs/toolkit';

export const listenerMiddleware = createListenerMiddleware();
